import ApiService from "../../api/api.service";
import { GET_EQUITIES_AND_BOND_DATA, DELETE_EQUITIES_AND_BOND_DATA, GET_EQUITIES_ADD_FORM_DATA, SAVE_EQUITIES_BOND_FORM,
 GET_SECURITY_LIST, GET_SECURITY_NAME, GET_SERIES_LIST, GET_SERIES_DETAIL, GET_EQUITY_EDIT_FORM_DETAIL, 
 UPDATE_EQUITY_BOND_FORM_DETAIL,} from "../actions.type";

const getDefaultEquitiesState = () => {
	return {
		equitiesAndBondData: {},
		equitiesAddFormData: {},
		saveEquitiesBondForm: {},
		securityList: {},
		securityName: {},
		seriesList: {},
		seriesDetail: {},
		equityEditFormDetail: {},
		updateEquityBondFormDetail: {},
	}
};

const state = getDefaultEquitiesState();

const getters = {

	getEquitiesAndBondData(state) {
		return state.equitiesAndBondData;
	},
	getEquitiesAddFormData(state) {
		return state.equitiesAddFormData;
	},
	getSaveEquitiesBondForm(state) {
		return state.saveEquitiesBondForm;
	},
	getSecurityList(state) {
		return state.securityList;
	},
	getSecurityName(state) {
		return state.securityName;
	},
	getSeriesList(state) {
		return state.seriesList;
	},
	getSeriesDetail(state) {
		return state.seriesDetail;
	},
	getEquityEditFormDetail(state) {
		return state.equityEditFormDetail;
	},
	getUpdateEquityBondFormDetail(state) {
		return state.updateEquityBondFormDetail;
	},

};

const mutations = {

	setEquitiesAndBondData (state, data) {
		state.equitiesAndBondData = data
	},

	setEquitiesAddFormData (state, data) {
		state.equitiesAddFormData = data
	},
	setSaveEquitiesBondForm (state, data) {
		state.saveEquitiesBondForm = data
	},
	setSecurityList (state, data) {
		state.securityList = data
	},
	setSecurityName (state, data) {
		state.securityName = data
	},
	setSeriesList (state, data) {
		state.seriesList = data
	},
	setSeriesDetail (state, data) {
		state.seriesDetail = data
	},
	setEquityEditFormDetail (state, data) {
		state.equityEditFormDetail = data
	},
	setUpdateEquityBondFormDetail (state, data) {
		state.updateEquityBondFormDetail = data
	},

};


const actions = {

	[GET_EQUITIES_AND_BOND_DATA](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEquitiesAndBondData',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[DELETE_EQUITIES_AND_BOND_DATA](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[GET_EQUITIES_ADD_FORM_DATA](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setEquitiesAddFormData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	[SAVE_EQUITIES_BOND_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSaveEquitiesBondForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_SECURITY_LIST](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSecurityList',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_SECURITY_NAME](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSecurityName',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_SERIES_LIST](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSeriesList',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_SERIES_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSeriesDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_EQUITY_EDIT_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEquityEditFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_EQUITY_BOND_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUpdateEquityBondFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},

};

export default {
	getters,
	actions,
	mutations,
	state
}